import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, vShow as _vShow, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c42ee004"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signage__container" }
const _hoisted_2 = { class: "d-flex flex-column gap flex-md-row align-items-md-center flex-grow-1" }
const _hoisted_3 = { class: "rooms-heading me-4" }
const _hoisted_4 = { class: "signage__storage-quota-container mt-2 mt-md-2" }
const _hoisted_5 = { class: "signage__storage-quota-label" }
const _hoisted_6 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--danger",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_8 = {
  key: 0,
  class: "receiver-status__badge__mobile receiver-status__badge__mobile--warning float-end",
  "aria-hidden": "true"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enter a signage list name. Example: Announcements", -1))
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "d-flex gap-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Hide", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Stop playing this signage list on Ditto receivers. This action overrides individual signage item settings.", -1))
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_19 = { class: "col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The list type cannot be edited.", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Enter the Google Slides presentation URL. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.airsquirrels.com/ditto/google-slides/source/portal",
    target: "_blank",
    rel: "noreferrer noopener"
  }, "Get step-by-step instructions"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_25 = {
  key: 0,
  class: "error mb-0"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Make all presentation edits in Google Slides. Ditto checks for presentation edits every 10 minutes.", -1))
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-sm-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select how long each presentation slide is shown.", -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Rooms", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Assign rooms to this signage list.", -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0 mb-3" }, "Takeover List", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enable Takeover List", -1))
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0 mb-3" }, "Scheduling", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Scheduled", -1))
const _hoisted_40 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Unscheduled signage lists will always be active unless they are hidden.", -1))
const _hoisted_42 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Date", -1))
const _hoisted_44 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Time", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-nowrap" }, "to", -1))
const _hoisted_47 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Day", -1))
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 0,
  class: "callout callout--no-max callout--danger mb-3"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--danger",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "There were errors generating signage. Click Save Signage to process again.", -1))
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "callout callout--no-max callout--informational mb-3"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--informational",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Generating signage. It may take a few moments to appear.", -1))
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 2,
  class: "callout callout--no-max callout--informational mb-3"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--informational",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Make all presentation edits in Google Slides. Ditto checks for presentation edits every 10 minutes.", -1))
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = { class: "ms-0 mb-2 me-2" }
const _hoisted_63 = { class: "ms-0 mb-2 me-2" }
const _hoisted_64 = { class: "ms-0 mb-2 me-2" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Duplicate", -1))
const _hoisted_66 = { class: "ms-0 mb-2 me-2" }
const _hoisted_67 = { class: "ms-0 mb-2 me-2" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Move", -1))
const _hoisted_69 = { class: "ms-0 mb-2 me-2" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delete", -1))
const _hoisted_71 = { class: "ms-auto" }
const _hoisted_72 = { key: 3 }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "px-1" }
const _hoisted_75 = { class: "d-flex flex-row my-3" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Name: ", -1))
const _hoisted_77 = { class: "d-flex flex-row mb-3" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Type: ", -1))
const _hoisted_79 = { class: "expanded-table__description" }
const _hoisted_80 = { class: "d-flex flex-row mb-3" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Order: ", -1))
const _hoisted_82 = { class: "expanded-table__description" }
const _hoisted_83 = { class: "d-flex flex-row mb-3" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Scheduled: ", -1))
const _hoisted_85 = { class: "expanded-table__description" }
const _hoisted_86 = {
  key: 0,
  class: "d-flex flex-row mb-3"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, null, -1))
const _hoisted_88 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { key: 2 }
const _hoisted_92 = { class: "d-flex flex-row mb-3" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Duration: ", -1))
const _hoisted_94 = { class: "expanded-table__description" }
const _hoisted_95 = { class: "d-flex align-items-center gap-2" }
const _hoisted_96 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_97 = { class: "d-flex flex-row mb-3" }
const _hoisted_98 = { class: "mx-auto" }
const _hoisted_99 = { class: "me-2" }
const _hoisted_100 = { class: "me-2" }
const _hoisted_101 = { class: "d-flex flex-row mb-3" }
const _hoisted_102 = { class: "mx-auto" }
const _hoisted_103 = { class: "me-2" }
const _hoisted_104 = { class: "me-2" }
const _hoisted_105 = { class: "signage__item d-flex align-items-center justify-content-between" }
const _hoisted_106 = { class: "d-flex align-items-center" }
const _hoisted_107 = { class: "signage__item-image-container me-3" }
const _hoisted_108 = {
  key: 2,
  class: "item__image",
  style: {"background":"url(images/signage-layout-images/staticweburlloading.png) center center / cover no-repeat"}
}
const _hoisted_109 = {
  key: 4,
  class: "item__image tooltip-hover",
  style: {"background":"url(images/signage-layout-images/staticweburlloading.png) center center / cover no-repeat"}
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-loading-overlay text-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon icon--x-large icon--danger icon--overlay",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
  ])
], -1))
const _hoisted_111 = {
  key: 5,
  class: "signage__item-name"
}
const _hoisted_112 = {
  key: 0,
  class: "receiver-status__badge__mobile receiver-status__badge__mobile--warning ms-2 float-end",
  "aria-hidden": "true"
}
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { key: 2 }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { class: "el-table signage__table" }
const _hoisted_117 = { class: "el-table__cell" }
const _hoisted_118 = {
  class: "cell",
  style: {"width":"50px"}
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "el-table__cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Order")
], -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "el-table__cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Name")
], -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Scheduled")
], -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "el-table__cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Duration")
], -1))
const _hoisted_123 = ["onClick"]
const _hoisted_124 = ["onClick"]
const _hoisted_125 = { class: "cell d-flex align-items-center" }
const _hoisted_126 = {
  class: "el-table__cell",
  style: {"width":"75px"}
}
const _hoisted_127 = { class: "cell d-flex align-items-center gap-2" }
const _hoisted_128 = { class: "signage__item-order" }
const _hoisted_129 = { class: "el-table__cell" }
const _hoisted_130 = { class: "cell d-flex align-items-center gap-2" }
const _hoisted_131 = { class: "signage__item-image-container" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-loading-overlay text-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon icon--x-large icon--danger icon--overlay",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
  ])
], -1))
const _hoisted_133 = [
  _hoisted_132
]
const _hoisted_134 = { class: "dt-list__content" }
const _hoisted_135 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_136 = ["onUpdate:modelValue"]
const _hoisted_137 = ["onClick"]
const _hoisted_138 = { key: 1 }
const _hoisted_139 = { class: "dt-list__sub-title" }
const _hoisted_140 = { class: "el-table__cell" }
const _hoisted_141 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_142 = { key: 0 }
const _hoisted_143 = { key: 1 }
const _hoisted_144 = { key: 2 }
const _hoisted_145 = ["onClick"]
const _hoisted_146 = { key: 0 }
const _hoisted_147 = { class: "receiver-status__badge receiver-status__badge--warning" }
const _hoisted_148 = {
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_149 = ["d"]
const _hoisted_150 = { class: "el-table__cell" }
const _hoisted_151 = { class: "cell d-inline-flex align-items-center signage__editable-table-cell" }
const _hoisted_152 = { class: "d-flex align-items-center gap-2" }
const _hoisted_153 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_154 = { class: "el-table__cell" }
const _hoisted_155 = { class: "cell d-flex justify-content-end align-items-center" }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = { key: 1 }
const _hoisted_158 = { key: 2 }
const _hoisted_159 = { key: 0 }
const _hoisted_160 = ["disabled", "onClick"]
const _hoisted_161 = ["disabled", "onClick"]
const _hoisted_162 = ["disabled", "onClick"]
const _hoisted_163 = ["disabled", "onClick"]
const _hoisted_164 = ["onClick"]
const _hoisted_165 = { key: 4 }
const _hoisted_166 = ["onClick"]
const _hoisted_167 = { key: 4 }
const _hoisted_168 = { key: 0 }
const _hoisted_169 = { key: 1 }
const _hoisted_170 = { class: "el-table signage__table" }
const _hoisted_171 = { class: "el-table__cell" }
const _hoisted_172 = {
  class: "cell",
  style: {"width":"50px"}
}
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "el-table__cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Order")
], -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "el-table__cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Name")
], -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Scheduled")
], -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "el-table__cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cell" }, "Duration")
], -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "signage__no-items" }, "No signage items")
    ])
  ])
], -1))
const _hoisted_178 = { class: "receiver-status__badge receiver-status__badge--warning" }
const _hoisted_179 = {
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_180 = ["d"]
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "Select Template Type", -1))
const _hoisted_182 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_183 = { class: "signage__layout-types" }
const _hoisted_184 = ["disabled", "onClick"]
const _hoisted_185 = { class: "signage__layout-type-button-content" }
const _hoisted_186 = ["src"]
const _hoisted_187 = { class: "signage__layout-types" }
const _hoisted_188 = ["disabled", "onClick"]
const _hoisted_189 = { class: "signage__layout-type-button-content" }
const _hoisted_190 = ["src"]
const _hoisted_191 = ["src"]
const _hoisted_192 = { class: "signage__layout-types" }
const _hoisted_193 = ["disabled", "onClick"]
const _hoisted_194 = { class: "signage__layout-type-button-content" }
const _hoisted_195 = ["src"]
const _hoisted_196 = { class: "dialog-footer" }
const _hoisted_197 = { class: "ms-2 d-inline-block" }
const _hoisted_198 = { class: "m-0" }
const _hoisted_199 = { class: "el-dialog__sub-title" }
const _hoisted_200 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_201 = { class: "d-flex gap-2" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Scheduled", -1))
const _hoisted_203 = { key: 0 }
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Signage List Schedule", -1))
const _hoisted_205 = { class: "list-unstyled d-flex flex-column m-0" }
const _hoisted_206 = { key: 0 }
const _hoisted_207 = { key: 1 }
const _hoisted_208 = { key: 2 }
const _hoisted_209 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Unscheduled signage items will always be active unless they are hidden.", -1))
const _hoisted_211 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Date", -1))
const _hoisted_213 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Time", -1))
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-nowrap" }, "-", -1))
const _hoisted_216 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Day", -1))
const _hoisted_218 = ["onClick"]
const _hoisted_219 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_220 = { class: "dialog-footer" }
const _hoisted_221 = { class: "m-0" }
const _hoisted_222 = { class: "el-dialog__sub-title" }
const _hoisted_223 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_224 = { key: 0 }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-0" }, "Image Duration", -1))
const _hoisted_226 = { class: "mt-4 mb-2" }
const _hoisted_227 = { key: 1 }
const _hoisted_228 = { class: "mt-4" }
const _hoisted_229 = { class: "mb-2 d-flex gap-2" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Play until end", -1))
const _hoisted_231 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_232 = { class: "dialog-footer" }
const _hoisted_233 = { class: "m-0" }
const _hoisted_234 = { class: "el-dialog__sub-title" }
const _hoisted_235 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_236 = { class: "m-0" }
const _hoisted_237 = { class: "dialog-footer" }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "Upload Media", -1))
const _hoisted_239 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_240 = { class: "mt-2" }
const _hoisted_241 = {
  class: "drag-drop-input-label",
  href: "#"
}
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "accepted-files" }, "Accepted file types: PNG, JPEG, JPG and MP4")
], -1))
const _hoisted_243 = { key: 1 }
const _hoisted_244 = { class: "drop-area" }
const _hoisted_245 = { class: "w-100" }
const _hoisted_246 = { class: "signage__item-image-container float-start" }
const _hoisted_247 = ["src"]
const _hoisted_248 = ["src"]
const _hoisted_249 = {
  key: 2,
  class: "signage__item-image-building text-center"
}
const _hoisted_250 = {
  key: 1,
  class: "signage__item-image-container float-start"
}
const _hoisted_251 = ["src"]
const _hoisted_252 = ["src"]
const _hoisted_253 = { key: 0 }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-1 fw-bold" }, "Audio", -1))
const _hoisted_255 = {
  key: 1,
  class: "callout callout--no-max callout--danger mt-3"
}
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--danger",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Upload Limit Exceeded", -1))
const _hoisted_258 = {
  key: 2,
  class: "callout callout--no-max callout--danger mt-3"
}
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--danger",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You reached your signage storage limit! Signage items cannot be created until more storage is added.", -1))
const _hoisted_261 = [
  _hoisted_259,
  _hoisted_260
]
const _hoisted_262 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_InlineTextLoader = _resolveComponent("InlineTextLoader")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ModelSelector = _resolveComponent("ModelSelector")!
  const _component_SignageListSelectionModal = _resolveComponent("SignageListSelectionModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({'d-flex align-items-center justify-items-between' : _ctx.windowWidth.value >= 576 })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "primary-color",
            to: "/signage"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Signage Lists")
            ]),
            _: 1
          }),
          _createTextVNode(" » " + _toDisplayString(_ctx.signageList.name), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(" Storage Used: "),
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              (_ctx.assetCapacityGb)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.usedStorageToSize) + " / " + _toDisplayString(_ctx.assetCapacityGb) + " " + _toDisplayString(_ctx.memoryUnitCheck), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.isSignageQuotaLoading]
            ])
          ]),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.assetQuotaPercentage.toFixed(2) + '%',
            placement: "bottom",
            "hide-after": 0,
            "show-after": 500
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_progress, {
                class: "signage__storage-quota-progress",
                "show-text": false,
                "stroke-width": 16,
                percentage: _ctx.assetQuotaPercentage
              }, null, 8, ["percentage"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({'mt-3 text-end' : _ctx.windowWidth.value < 576 })
      }, [
        _createVNode(_component_router_link, { to: '/signage' }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { class: "ms-3" }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          disabled: !_ctx.isUrlValid,
          onClick: _ctx.onSignageListSave,
          class: "ms-3",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save Signage")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])), [
          [_directive_loading, _ctx.isSaving]
        ])
      ], 2)
    ], 2),
    (_ctx.showTierCallout || (_ctx.isImport && _ctx.signageList.importError))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.showTierCallout)
            ? (_openBlock(), _createBlock(_component_TierLimit, {
                key: 0,
                isCallout: true,
                message: _ctx.tierLimitReachedMessage
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          (_ctx.isImport && _ctx.signageList.importError)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["callout callout--no-max callout--danger", {'mt-3' : _ctx.showTierCallout}])
              }, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.importErrorMessage), 1)
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["dt-container dt-container--tabbed", {'p-3' : _ctx.windowWidth.value < 576}])
    }, [
      (_ctx.listConflict && _ctx.windowWidth.value < 576)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Overview",
            name: "overview"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                "validate-on-rule-change": false,
                "label-position": "top",
                model: _ctx.signageList,
                rules: _ctx.overviewScheduleFormRules,
                ref: "overviewScheduleForm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_form_item, {
                          label: "Signage List Name",
                          prop: "name"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _createVNode(_component_el_input, {
                              placeholder: "Signage List Name",
                              modelValue: _ctx.signageList.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageList.name) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_form_item, { prop: "hideListFromDisplay" }, {
                          default: _withCtx(() => [
                            _createElementVNode("label", _hoisted_13, [
                              _createVNode(_component_el_switch, {
                                modelValue: _ctx.signageList.hideListFromDisplay,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageList.hideListFromDisplay) = $event))
                              }, null, 8, ["modelValue"]),
                              _hoisted_14
                            ]),
                            _hoisted_15
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_el_form_item, { label: "Signage Layout" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createTextVNode("Apply a "),
                              _createVNode(_component_router_link, {
                                class: "primary-color",
                                target: "_blank",
                                rel: "noreferrer noopener",
                                to: "/signage/layouts"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("layout")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(". Clear selection (✕) to display items full screen across your displays.")
                            ]),
                            _createVNode(_component_el_select, {
                              filterable: "",
                              clearable: "",
                              placeholder: "Select a layout",
                              modelValue: _ctx.signageList.signageLayout,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageList.signageLayout) = $event)),
                              "value-key": "id"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedSignageLayouts, (layout) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: layout.id,
                                    label: layout.name,
                                    value: layout
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(layout.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            (_ctx.signageList.signageLayout && _ctx.signageList.signageLayout.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createVNode(_component_router_link, {
                                    to: `/signage/layouts/${_ctx.signageList.signageLayout.id}`,
                                    class: "primary-color"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Icon, {
                                        class: "me-1",
                                        icon: _ctx.mdiOpenInNew
                                      }, null, 8, ["icon"]),
                                      _createTextVNode(" Open Layout: " + _toDisplayString(_ctx.signageList.signageLayout.name), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["to"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_el_form_item, { label: "Signage List Type" }, {
                          default: _withCtx(() => [
                            _hoisted_20,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.listTypeDisplay,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listTypeDisplay) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (_ctx.isImport)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_el_form_item, {
                                prop: "url",
                                label: "URL"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_24,
                                  _createVNode(_component_el_input, {
                                    class: _normalizeClass({'url-invalid' : (!_ctx.isUrlValid),  'url-valid' : (_ctx.isUrlValid) }),
                                    modelValue: _ctx.signageList.importUrl,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageList.importUrl) = $event)),
                                    "suffix-icon": {'el-icon-warning url-invalid':(!_ctx.isUrlValid), 'el-icon-check url-valid':(_ctx.isUrlValid)}
                                  }, null, 8, ["class", "modelValue", "suffix-icon"]),
                                  (!_ctx.isUrlValid)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.invalidUrlText), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.signageList.importUrl)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                        _createVNode(_component_Icon, {
                                          class: "icon icon--small me-1 mb-1",
                                          icon: _ctx.mdiInformationOutline
                                        }, null, 8, ["icon"]),
                                        _hoisted_27
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_el_form_item, {
                                prop: "importDuration",
                                label: "Duration"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_30,
                                  _createVNode(_component_VueDatePicker, {
                                    "enable-seconds": true,
                                    clearable: false,
                                    "hide-input-icon": "",
                                    modelValue: _ctx.importDuration,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.importDuration) = $event)),
                                    "time-picker": "",
                                    "auto-apply": "",
                                    "min-time": { hours: 0, minutes: 0, seconds: 1 },
                                    position: "left",
                                    teleport: true
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_el_form_item, { prop: "rooms" }, {
                        default: _withCtx(() => [
                          _hoisted_32,
                          _hoisted_33,
                          _createVNode(_component_el_button, {
                            type: "primary",
                            plain: "",
                            class: "mb-3",
                            onClick: _ctx.toggleManageRooms
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Manage Rooms (" + _toDisplayString(_ctx.signageList && _ctx.signageList.rooms ? _ctx.signageList.rooms.length : 0) + ")", 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_table, {
                            data: _ctx.signageList.rooms,
                            "empty-text": "No rooms assigned"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: "Name",
                                prop: "roomName"
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ]),
                        _: 1
                      })
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_el_form_item, { prop: "overrideTimeSet" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tooltip, {
                            disabled: !(_ctx.hasSignageOverride || (!_ctx.hasSignageOverride && !_ctx.isSystemRole)),
                            effect: "dark",
                            content: _ctx.signageOverrideDisableText,
                            placement: "bottom",
                            "hide-after": 0,
                            "show-after": 500
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("label", null, [
                                _createVNode(_component_el_switch, {
                                  disabled: (_ctx.hasSignageOverride || (!_ctx.hasSignageOverride && !_ctx.isSystemRole)),
                                  modelValue: _ctx.signageList.override,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.signageList.override) = $event))
                                }, null, 8, ["disabled", "modelValue"]),
                                _hoisted_36
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled", "content"]),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.signageList.scheduledTimeSet ? '' : 'mb-0')
                          }, "A takeover list replaces all other signage lists in the selected rooms while active. If no schedule is set, it will remain active until this setting is turned off.", 2)
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, !_ctx.isOrganizationBasic]
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_el_form_item, { prop: "scheduledTimeSet" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tooltip, {
                            disabled: _ctx.hasScheduling,
                            effect: "dark",
                            content: _ctx.upgradeText,
                            placement: "bottom",
                            "hide-after": 0,
                            "show-after": 500
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("label", null, [
                                _createVNode(_component_el_switch, {
                                  disabled: _ctx.disableScheduling,
                                  modelValue: _ctx.signageList.scheduledTimeSet,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.signageList.scheduledTimeSet) = $event))
                                }, null, 8, ["disabled", "modelValue"]),
                                _hoisted_39
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled", "content"]),
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.signageList.scheduledTimeSet ? '' : 'mb-0')
                          }, "Set a schedule for the signage list.", 2),
                          (!_ctx.signageList.scheduledTimeSet)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _createVNode(_component_Icon, {
                                  class: "icon icon--x-large icon--warning",
                                  icon: _ctx.mdiAlertCircle
                                }, null, 8, ["icon"]),
                                _hoisted_41
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.signageList.scheduledTimeSet)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'signage__mass-scheduling-calendars' : _ctx.windowWidth.value >= 576 })
                            }, [
                              _createVNode(_component_el_form_item, { prop: "isDateEnabled" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.signageList.isDateEnabled,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.signageList.isDateEnabled) = $event)),
                                      disabled: _ctx.disableScheduling
                                    }, null, 8, ["modelValue", "disabled"]),
                                    _hoisted_43
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass({ 'signage__inactive-schedule-item' : _ctx.disableScheduling })
                                  }, [
                                    _createVNode(_component_VueDatePicker, {
                                      range: true,
                                      clearable: false,
                                      "hide-input-icon": "",
                                      modelValue: _ctx.dates,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dates) = $event)),
                                      "auto-apply": "",
                                      placeholder: "Date / Date range",
                                      "enable-time-picker": false,
                                      "month-change-on-scroll": false,
                                      "menu-class-name": "signage__duration-picker",
                                      "min-date": new Date(),
                                      "week-start": "0",
                                      "hide-offset-dates": "",
                                      disabled: _ctx.disableScheduling
                                    }, null, 8, ["modelValue", "min-date", "disabled"])
                                  ], 2)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { prop: "isTimeEnabled" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.signageList.isTimeEnabled,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.signageList.isTimeEnabled) = $event)),
                                      disabled: _ctx.disableScheduling
                                    }, null, 8, ["modelValue", "disabled"]),
                                    _hoisted_45
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass([{ 'signage__inactive-schedule-item' : _ctx.disableScheduling }, "d-flex align-items-center gap-4"])
                                  }, [
                                    _createVNode(_component_VueDatePicker, {
                                      clearable: false,
                                      "hide-input-icon": "",
                                      modelValue: _ctx.startTime,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startTime) = $event)),
                                      "auto-apply": "",
                                      placeholder: "Start time",
                                      "time-picker": "",
                                      "is-24": false,
                                      "menu-class-name": "signage__duration-picker",
                                      disabled: _ctx.disableScheduling
                                    }, null, 8, ["modelValue", "disabled"]),
                                    _hoisted_46,
                                    _createVNode(_component_VueDatePicker, {
                                      clearable: false,
                                      "hide-input-icon": "",
                                      modelValue: _ctx.endTime,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endTime) = $event)),
                                      "auto-apply": "",
                                      placeholder: "End time",
                                      "time-picker": "",
                                      "is-24": false,
                                      "menu-class-name": "signage__duration-picker",
                                      disabled: _ctx.disableScheduling
                                    }, null, 8, ["modelValue", "disabled"])
                                  ], 2)
                                ]),
                                _: 1
                              })
                            ], 2),
                            _createVNode(_component_el_form_item, { prop: "isDayEnabled" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_47, [
                                  _createVNode(_component_el_switch, {
                                    modelValue: _ctx.signageList.isDayEnabled,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.signageList.isDayEnabled) = $event)),
                                    disabled: _ctx.disableScheduling
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _hoisted_48
                                ]),
                                _createElementVNode("ul", {
                                  class: _normalizeClass(["signage__days-of-week", { 'signage__inactive-schedule-item' : _ctx.disableScheduling, 'd-block' : _ctx.windowWidth.value < 576 }])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      onClick: ($event: any) => (_ctx.onDetailsDayOfWeekClick(day.value)),
                                      class: _normalizeClass({ active : _ctx.signageList.isDayEnabled && _ctx.signageList.activeDaysOfWeek && _ctx.signageList.activeDaysOfWeek.includes(day.value), 'm-2' : _ctx.windowWidth.value < 576 }),
                                      key: day.value
                                    }, _toDisplayString(day.name), 11, _hoisted_49))
                                  }), 128))
                                ], 2)
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { name: "signage" }, {
            label: _withCtx(() => [
              _createElementVNode("span", null, "Signage Items (" + _toDisplayString(_ctx.orderedSignageItems && _ctx.orderedSignageItems.length ? _ctx.orderedSignageItems.length : 0) + ")", 1)
            ]),
            default: _withCtx(() => [
              (_ctx.importErrors)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_53))
                : _createCommentVNode("", true),
              (_ctx.isImport && _ctx.importGenerating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_57))
                : _createCommentVNode("", true),
              (_ctx.isImport)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass({'d-flex align-items-center justify-content-between mb-4' : _ctx.windowWidth.value >= 576 })
              }, [
                _createVNode(_component_el_tooltip, {
                  disabled: !_ctx.selectedSignages.length || _ctx.hasScheduling,
                  effect: "dark",
                  content: _ctx.upgradeText,
                  placement: "bottom",
                  "hide-after": 0,
                  "show-after": 500
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_62, [
                      _createVNode(_component_el_button, {
                        class: _normalizeClass({'mb-2' : _ctx.windowWidth.value < 576}),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onMassScheduleClick(null))),
                        disabled: !_ctx.hasScheduling || !_ctx.selectedSignages.length
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, { icon: _ctx.mdiCalendarClock }, null, 8, ["icon"]),
                          _createTextVNode(" Schedule ")
                        ]),
                        _: 1
                      }, 8, ["class", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "content"]),
                _createVNode(_component_el_tooltip, {
                  disabled: (!_ctx.selectedSignages.length || _ctx.hasListManagement) && !_ctx.isImport,
                  effect: "dark",
                  content: _ctx.massDurationTooltipText,
                  placement: "bottom",
                  "hide-after": 0,
                  "show-after": 500
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_63, [
                      _createVNode(_component_el_button, {
                        class: _normalizeClass({'mb-2' : _ctx.windowWidth.value < 576}),
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onMassDurationClick(null))),
                        disabled: !_ctx.hasListManagement || !_ctx.selectedSignages.length || _ctx.isImport
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, { icon: _ctx.mdiClockTimeFive }, null, 8, ["icon"]),
                          _createTextVNode(" Duration ")
                        ]),
                        _: 1
                      }, 8, ["class", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "content"]),
                (!_ctx.isImport)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      disabled: !_ctx.selectedSignages.length || _ctx.hasListManagement,
                      effect: "dark",
                      content: _ctx.upgradeText,
                      placement: "bottom",
                      "hide-after": 0,
                      "show-after": 500
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_64, [
                          _createVNode(_component_el_button, {
                            class: _normalizeClass([{'mb-2' : _ctx.windowWidth.value < 576}, "el-button el-button--default"]),
                            onClick: _ctx.duplicateSignages,
                            disabled: !_ctx.hasListManagement || !_ctx.isMassSelect || _ctx.allowMassDuplicate
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Icon, { icon: _ctx.mdiCardMultiple }, null, 8, ["icon"]),
                              _hoisted_65
                            ]),
                            _: 1
                          }, 8, ["class", "onClick", "disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "content"]))
                  : _createCommentVNode("", true),
                (!_ctx.isImport)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      disabled: !_ctx.selectedSignages.length || _ctx.hasListManagement,
                      effect: "dark",
                      content: _ctx.upgradeText,
                      placement: "bottom",
                      "hide-after": 0,
                      "show-after": 500
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_66, [
                          _createVNode(_component_el_button, {
                            class: _normalizeClass([{'mb-2' : _ctx.windowWidth.value < 576}, "el-button el-button--default"]),
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showHideSignageItems(null))),
                            disabled: !_ctx.hasListManagement || !_ctx.selectedSignages.length
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Icon, {
                                icon: _ctx.isSelectedHidden ? _ctx.mdiEye : _ctx.mdiEyeOff
                              }, null, 8, ["icon"]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.hideButtonText), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "content"]))
                  : _createCommentVNode("", true),
                (!_ctx.isImport)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 2,
                      disabled: !_ctx.selectedSignages.length || _ctx.hasListManagement,
                      effect: "dark",
                      content: _ctx.upgradeText,
                      placement: "bottom",
                      "hide-after": 0,
                      "show-after": 500
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_67, [
                          _createVNode(_component_el_button, {
                            class: _normalizeClass([{'mb-2' : _ctx.windowWidth.value < 576}, "el-button el-button--default"]),
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.moveItemHandler(null))),
                            disabled: !_ctx.hasListManagement || !_ctx.isMassSelect
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Icon, { icon: _ctx.mdiCursorMove }, null, 8, ["icon"]),
                              _hoisted_68
                            ]),
                            _: 1
                          }, 8, ["class", "disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "content"]))
                  : _createCommentVNode("", true),
                (!_ctx.isImport)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 3,
                      disabled: !_ctx.selectedSignages.length || _ctx.hasListManagement,
                      effect: "dark",
                      content: _ctx.upgradeText,
                      placement: "bottom",
                      "hide-after": 0,
                      "show-after": 500
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_69, [
                          _createVNode(_component_el_button, {
                            class: _normalizeClass([{'mb-2' : _ctx.windowWidth.value < 576}, "el-button el-button--default"]),
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onDeleteClick(null))),
                            disabled: !_ctx.hasListManagement || !_ctx.selectedSignages.length
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Icon, { icon: _ctx.mdiDelete }, null, 8, ["icon"]),
                              _hoisted_70
                            ]),
                            _: 1
                          }, 8, ["class", "disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "content"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_71, [
                  (!_ctx.isImport)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        disabled: _ctx.isMassMediaUploadAllowed,
                        effect: "dark",
                        content: _ctx.upgradeText,
                        placement: "bottom",
                        "show-after": 500,
                        "hide-after": 0
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(_component_el_button, {
                              class: _normalizeClass([{'ms-0 mb-2 me-2 float-end' : _ctx.windowWidth.value < 576, 'ms-3' : _ctx.windowWidth.value >= 576}, "el-button el-button--default"]),
                              disabled: !_ctx.isMassMediaUploadAllowed,
                              onClick: _ctx.onMassUploadClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Upload Media")
                              ]),
                              _: 1
                            }, 8, ["class", "disabled", "onClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled", "content"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isImport)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: _normalizeClass({'ms-0 mb-2 me-2 float-end' : _ctx.windowWidth.value < 576, 'ms-3' : _ctx.windowWidth.value >= 576}),
                        type: "primary",
                        plain: "",
                        onClick: _ctx.onNewItemHandler
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("New Item")
                        ]),
                        _: 1
                      }, 8, ["class", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              (_ctx.orderedSignageItems && _ctx.orderedSignageItems.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    (_ctx.windowWidth.value < 576)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                            onSelectionChange: _ctx.handleSelectionChange,
                            "empty-text": "No signage items",
                            "label-position": "top",
                            data: _ctx.orderedSignageItems,
                            style: {"width":"100%"},
                            class: "signage__table",
                            onRowClick: _ctx.onRowClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                type: "expand",
                                width: "55"
                              }, {
                                default: _withCtx((props) => [
                                  _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("div", _hoisted_75, [
                                      _hoisted_76,
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_router_link, {
                                          to: `/signage/${_ctx.selectedSignageListId}/${props.row.id}`
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(props.row.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_77, [
                                      _hoisted_78,
                                      _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.setLayoutTypeDisplayName(props.row.layoutType)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_80, [
                                      _hoisted_81,
                                      _createElementVNode("div", _hoisted_82, _toDisplayString(props.row.order), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_83, [
                                      _hoisted_84,
                                      _createElementVNode("div", _hoisted_85, _toDisplayString(props.row.scheduledTimeSet ? 'Yes' : 'No'), 1)
                                    ]),
                                    (props.row.scheduledTimeSet)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                          _hoisted_87,
                                          _createElementVNode("div", null, [
                                            _createElementVNode("ul", _hoisted_88, [
                                              (props.row.isDateEnabled)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_89, _toDisplayString(new Date(props.row.startDate).toLocaleDateString()) + " - " + _toDisplayString(new Date(props.row.endDate).toLocaleDateString()), 1))
                                                : _createCommentVNode("", true),
                                              (props.row.isTimeEnabled)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_90, _toDisplayString(_ctx.convert24to12(props.row.startTime)) + " - " + _toDisplayString(_ctx.convert24to12(props.row.endTime)), 1))
                                                : _createCommentVNode("", true),
                                              (props.row.isDayEnabled)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_91, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.activeDaysOfWeek.sort(_ctx.sortByDay), (day, i) => {
                                                      return (_openBlock(), _createElementBlock("span", {
                                                        key: String(day)
                                                      }, [
                                                        _createTextVNode(_toDisplayString(day), 1),
                                                        (Number(i) < props.row.activeDaysOfWeek.length - 1)
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createTextVNode(", ")
                                                            ], 64))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_92, [
                                      _hoisted_93,
                                      _createElementVNode("div", _hoisted_94, [
                                        (!props.row.playUntilEnd && props.row.finalSignageAsset && props.row.finalSignageAsset.assetType == 'image')
                                          ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                                              key: 0,
                                              "enable-seconds": true,
                                              clearable: false,
                                              "hide-input-icon": "",
                                              "menu-class-name": "signage__time-picker signage__time-picker--duration",
                                              modelValue: _ctx.durations[props.row.id],
                                              "onUpdate:modelValue": [($event: any) => ((_ctx.durations[props.row.id]) = $event), ($event: any) => (_ctx.onTimePickerUpdate($event, props.row, 'durationToDisplay'))],
                                              "time-picker": "",
                                              "auto-apply": "",
                                              "min-time": { hours: 0, minutes: 0, seconds: 1 },
                                              teleport: true
                                            }, {
                                              "dp-input": _withCtx(({ value }) => [
                                                _createElementVNode("div", _hoisted_95, [
                                                  _createElementVNode("span", null, _toDisplayString(value), 1),
                                                  _createVNode(_component_Icon, {
                                                    class: "m-0",
                                                    icon: _ctx.mdiPencil
                                                  }, null, 8, ["icon"])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                          : (_openBlock(), _createBlock(_component_el_popover, {
                                              key: 1,
                                              placement: "bottom",
                                              title: !props.row.playUntilEnd?'Duration':'Loop',
                                              width: 200,
                                              trigger: "click"
                                            }, {
                                              reference: _withCtx(() => [
                                                (!props.row.playUntilEnd)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: "d-flex align-items-center gap-2",
                                                      onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"]))
                                                    }, [
                                                      _createElementVNode("span", null, _toDisplayString(_ctx.displayDuration(props.row.durationToDisplay)), 1),
                                                      _createVNode(_component_Icon, {
                                                        class: "m-0",
                                                        icon: _ctx.mdiPencil
                                                      }, null, 8, ["icon"])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", {
                                                      key: 1,
                                                      class: "d-flex align-items-center gap-2",
                                                      onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["prevent"]))
                                                    }, [
                                                      _createElementVNode("span", null, _toDisplayString(_ctx.displayLoop(props.row.playUntilEndLoopCount)), 1),
                                                      _createVNode(_component_Icon, {
                                                        class: "m-0",
                                                        icon: _ctx.mdiPencil
                                                      }, null, 8, ["icon"])
                                                    ]))
                                              ]),
                                              default: _withCtx(() => [
                                                ((props.row.finalSignageAsset && props.row.finalSignageAsset.assetType == 'video') || props.row.layoutType === 'youtubevideo')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                      _createVNode(_component_el_switch, {
                                                        onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop","prevent"])),
                                                        modelValue: props.row.playUntilEnd,
                                                        "onUpdate:modelValue": ($event: any) => ((props.row.playUntilEnd) = $event)
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                      _createTextVNode(" Play until end ")
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (!props.row.playUntilEnd)
                                                  ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                                                      key: 1,
                                                      "enable-seconds": "",
                                                      clearable: false,
                                                      "hide-input-icon": "",
                                                      "menu-class-name": "signage__time-picker signage__time-picker--duration w-100",
                                                      modelValue: _ctx.durations[props.row.id],
                                                      "onUpdate:modelValue": [($event: any) => ((_ctx.durations[props.row.id]) = $event), ($event: any) => (_ctx.onTimePickerUpdate($event, props.row, 'durationToDisplay'))],
                                                      "time-picker": "",
                                                      "auto-apply": "",
                                                      "min-time": { hours: 0, minutes: 0, seconds: 1 },
                                                      teleport: true
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                  : (_openBlock(), _createBlock(_component_el_input_number, {
                                                      key: 2,
                                                      modelValue: props.row.playUntilEndLoopCount,
                                                      "onUpdate:modelValue": ($event: any) => ((props.row.playUntilEndLoopCount) = $event),
                                                      min: 1,
                                                      size: "small",
                                                      label: "loop",
                                                      class: "w-100"
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                              ]),
                                              _: 2
                                            }, 1032, ["title"]))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_97, [
                                      _createElementVNode("div", _hoisted_98, [
                                        (!_ctx.isImport)
                                          ? (_openBlock(), _createBlock(_component_el_button, {
                                              key: 0,
                                              class: "me-2",
                                              type: "primary",
                                              circle: "",
                                              plain: "",
                                              onClick: ($event: any) => (_ctx.$router.push('/signage/' + _ctx.mutatableSignageItemsStateObject.signageListId + '/' + props.row.id))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Icon, {
                                                  class: "dt-icon--large",
                                                  icon: _ctx.mdiPencil
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (!_ctx.isImport)
                                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                              key: 1,
                                              disabled: _ctx.hasListManagement,
                                              effect: "dark",
                                              content: _ctx.upgradeText,
                                              placement: "bottom",
                                              "hide-after": 0,
                                              "show-after": 500
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_99, [
                                                  _createVNode(_component_el_button, {
                                                    disabled: !_ctx.hasListManagement,
                                                    type: "primary",
                                                    circle: "",
                                                    plain: "",
                                                    onClick: ($event: any) => (_ctx.showHideSignageItems(props.row))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, {
                                                        class: "dt-icon--large",
                                                        icon: props.row.hideListFromDisplay ? _ctx.mdiEye : _ctx.mdiEyeOff
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["disabled", "onClick"])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled", "content"]))
                                          : _createCommentVNode("", true),
                                        (!_ctx.isImport)
                                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                              key: 2,
                                              disabled: _ctx.hasListManagement,
                                              effect: "dark",
                                              content: _ctx.upgradeText,
                                              placement: "bottom",
                                              "hide-after": 0,
                                              "show-after": 500
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_100, [
                                                  _createVNode(_component_el_button, {
                                                    disabled: !_ctx.hasListManagement,
                                                    type: "primary",
                                                    circle: "",
                                                    plain: "",
                                                    onClick: ($event: any) => (_ctx.moveItemHandler(props.row))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, {
                                                        class: "dt-icon--large",
                                                        icon: _ctx.mdiCursorMove
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["disabled", "onClick"])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled", "content"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_101, [
                                      _createElementVNode("div", _hoisted_102, [
                                        (!_ctx.isImport)
                                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                              key: 0,
                                              disabled: _ctx.hasListManagement,
                                              effect: "dark",
                                              content: _ctx.upgradeText,
                                              placement: "bottom",
                                              "hide-after": 0,
                                              "show-after": 500
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_103, [
                                                  (_ctx.allowDuplicate(props.row))
                                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                                        key: 0,
                                                        disabled: !_ctx.hasListManagement,
                                                        type: "primary",
                                                        circle: "",
                                                        plain: "",
                                                        onClick: ($event: any) => (_ctx.duplicateItemHandler(props.row))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_Icon, {
                                                            class: "dt-icon--large",
                                                            icon: _ctx.mdiCardMultiple
                                                          }, null, 8, ["icon"])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["disabled", "onClick"]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled", "content"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_el_tooltip, {
                                          disabled: _ctx.hasScheduling,
                                          effect: "dark",
                                          content: _ctx.upgradeText,
                                          placement: "bottom",
                                          "hide-after": 0,
                                          "show-after": 500
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_104, [
                                              _createVNode(_component_el_button, {
                                                disabled: !_ctx.hasScheduling,
                                                type: "primary",
                                                circle: "",
                                                plain: "",
                                                onClick: ($event: any) => (_ctx.onMassScheduleClick(props.row))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Icon, {
                                                    class: "dt-icon--large",
                                                    icon: _ctx.mdiCalendarClock
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1032, ["disabled", "onClick"])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "content"]),
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          circle: "",
                                          plain: "",
                                          onClick: ($event: any) => (_ctx.onMassDurationClick(props.row))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Icon, {
                                              class: "dt-icon--large",
                                              icon: _ctx.mdiClockTimeFive
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        (!_ctx.isImport)
                                          ? (_openBlock(), _createBlock(_component_el_button, {
                                              key: 1,
                                              type: "danger",
                                              circle: "",
                                              plain: "",
                                              onClick: ($event: any) => (_ctx.deleteSignageItemHandler(props.row))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Icon, {
                                                  class: "dt-icon--large",
                                                  icon: _ctx.mdiDelete
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                type: "selection",
                                width: "55"
                              }),
                              _createVNode(_component_el_table_column, { label: "Signage" }, {
                                default: _withCtx((props) => [
                                  _createElementVNode("div", _hoisted_105, [
                                    _createElementVNode("div", _hoisted_106, [
                                      _createElementVNode("div", _hoisted_107, [
                                        (props.row.layoutType === 'youtubevideo')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "item__image",
                                              style: _normalizeStyle({ background: 'url(https://img.youtube.com/vi/' + props.row.layoutData.videoId + '/hqdefault.jpg) center center / cover no-repeat' })
                                            }, null, 4))
                                          : (props.row.wipThumb && props.row.layoutType != "media" && props.row.layoutType != "mediaquadrants" && !props.row.finalAssetGenerationError)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "item__image",
                                                style: _normalizeStyle({ background: 'url(data:image/png;base64,' + props.row.wipThumb + ') center center / cover no-repeat' })
                                              }, null, 4))
                                            : ((props.row.refreshedLayout && !_ctx.isImport && props.row.finalSignageAsset && props.row.finalSignageAsset.thumbUrl && !props.row.finalAssetGenerationError) || (_ctx.isImport || props.row.layoutType == "mediaquadrants") && (props.row.finalSignageAsset && props.row.finalSignageAsset.remoteUploadPending && !props.row.finalAssetGenerationError))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_108))
                                              : ((!props.row.refreshedLayout || _ctx.isImport) && props.row.finalSignageAsset && props.row.finalSignageAsset.thumbUrl && !props.row.finalAssetGenerationError)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 3,
                                                    class: "item__image",
                                                    style: _normalizeStyle({ background: 'url(' + props.row.finalSignageAsset.thumbUrl + ') center center / cover no-repeat' })
                                                  }, null, 4))
                                                : (props.row.finalAssetGenerationError)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                                      _hoisted_110,
                                                      (props.row.layoutType !== 'youtubevideo' && props.row.finalSignageAsset && props.row.finalSignageAsset.remoteUploadPending)
                                                        ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                                            key: 0,
                                                            class: "signage__item-image-building"
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                        (_ctx.windowWidth.value > 576)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString(props.row.name), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (props.row.finalSignageAsset && props.row.finalSignageAsset.remoteUploadPending)
                                        ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                            key: 0,
                                            class: "signage__item-image-building"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.isListScheuleConflicted(props.row.id))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_112))
                                      : _createCommentVNode("", true),
                                    (props.row.storageQuotaMet)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                          _createVNode(_component_Icon, {
                                            class: _normalizeClass(["signage__hidden-icon", props.row.hideFromDisplay ? 'ms-3' : 'm-3']),
                                            icon: _ctx.mdiFolderAlert
                                          }, null, 8, ["class", "icon"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (props.row.hideFromDisplay)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                          _createVNode(_component_Icon, {
                                            class: _normalizeClass(["signage__hidden-icon", props.row.storageQuotaMet ? 'ms-3' : 'm-3']),
                                            icon: _ctx.mdiEyeOff
                                          }, null, 8, ["class", "icon"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onSelectionChange", "data", "onRowClick"])), [
                            [_directive_loading, _ctx.isSignageListItemsLoading]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _createElementVNode("table", _hoisted_116, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_117, [
                                  _createElementVNode("div", _hoisted_118, [
                                    _createVNode(_component_el_checkbox, {
                                      "model-value": _ctx.selectedSignages.length > 0,
                                      indeterminate: _ctx.isIndeterminate,
                                      onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onSignageItemCheckAll($event)))
                                    }, null, 8, ["model-value", "indeterminate"])
                                  ])
                                ]),
                                _hoisted_119,
                                _hoisted_120,
                                _hoisted_121,
                                _hoisted_122
                              ])
                            ]),
                            _createVNode(_component_draggable, {
                              disabled: _ctx.isImport,
                              handle: ".signage__drag-handle",
                              class: "el-table el-table--enable-row-hover el-table__body",
                              tag: "tbody",
                              "component-data": { data: _ctx.orderedSignageItems },
                              modelValue: _ctx.orderedSignageItems,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.orderedSignageItems) = $event)),
                              "item-key": "id"
                            }, {
                              item: _withCtx(({element, index}) => [
                                _createElementVNode("tr", {
                                  onClick: ($event: any) => (_ctx.onRowClick(element)),
                                  class: "el-table__row"
                                }, [
                                  _createElementVNode("td", {
                                    class: "el-table__cell",
                                    style: {"width":"50px"},
                                    onClick: _withModifiers(($event: any) => (_ctx.onSignageItemCheck(element)), ["stop","prevent"])
                                  }, [
                                    _createElementVNode("div", _hoisted_125, [
                                      _createVNode(_component_el_checkbox, {
                                        "model-value": _ctx.selectedSignagesIdMap.includes(element.id)
                                      }, null, 8, ["model-value"])
                                    ])
                                  ], 8, _hoisted_124),
                                  _createElementVNode("td", _hoisted_126, [
                                    _createElementVNode("div", _hoisted_127, [
                                      (!_ctx.isImport)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            class: "signage__drag-handle",
                                            icon: _ctx.mdiDragHorizontalVariant
                                          }, null, 8, ["icon"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_128, _toDisplayString(index + 1), 1)
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_129, [
                                    _createElementVNode("div", _hoisted_130, [
                                      _createVNode(_component_el_tooltip, {
                                        effect: "dark",
                                        content: "Generating signage. It may take a few moments to appear.",
                                        placement: "bottom",
                                        "hide-after": 0,
                                        "show-after": 500,
                                        "popper-class": "signage__asset-building-tooltip",
                                        disabled: element.layoutType === 'youtubevideo' || (!element.finalSignageAsset || !element.finalSignageAsset.remoteUploadPending || element.finalAssetGenerationError)
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_131, [
                                            (element.layoutType === 'youtubevideo')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: "item__image",
                                                  style: _normalizeStyle({ background: 'url(https://img.youtube.com/vi/' + element.layoutData.videoId + '/hqdefault.jpg) center center / cover no-repeat' })
                                                }, null, 4))
                                              : (element.wipThumb && element.layoutType != "media" && element.layoutType != "mediaquadrants" && !element.finalAssetGenerationError)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: "item__image",
                                                    style: _normalizeStyle({ background: 'url(data:image/png;base64,'+element.wipThumb+') center center / cover no-repeat'})
                                                  }, null, 4))
                                                : (element.refreshedLayout && element.finalSignageAsset && element.finalSignageAsset.thumbUrl && !element.finalAssetGenerationError || (_ctx.isImport && !element.finalSignageAsset && !element.finalAssetGenerationError) || (element.layoutType == "mediaquadrants" && element.finalSignageAsset && element.finalSignageAsset.remoteUploadPending && !element.finalAssetGenerationError))
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 2,
                                                      class: "item__image",
                                                      style: _normalizeStyle({ background: 'url(images/signage-layout-images/staticweburlloading.png) center center / cover no-repeat' })
                                                    }, null, 4))
                                                  : (!element.refreshedLayout && element.finalSignageAsset && element.finalSignageAsset.thumbUrl && !element.finalAssetGenerationError)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 3,
                                                        class: "item__image",
                                                        style: _normalizeStyle({ background: 'url('+element.finalSignageAsset.thumbUrl+') center center / cover no-repeat' })
                                                      }, null, 4))
                                                    : (element.finalAssetGenerationError)
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 4,
                                                          class: "item__image tooltip-hover",
                                                          style: _normalizeStyle({ background: 'url(images/signage-layout-images/staticweburlloading.png) center center / cover no-repeat' })
                                                        }, _hoisted_133, 4))
                                                      : _createCommentVNode("", true),
                                            (element.layoutType != 'youtubevideo' && !element.finalSignageAsset && !element.finalAssetGenerationError || (element.finalSignageAsset && element.finalSignageAsset.remoteUploadPending))
                                              ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                                  key: 5,
                                                  class: "signage__item-image-building"
                                                }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled"]),
                                      _createElementVNode("div", _hoisted_134, [
                                        (!_ctx.isImport && _ctx.canEditName(element.layoutType))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                              (_ctx.signageItemNameBeingEditedId == element.id)
                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                    key: 0,
                                                    class: "dt-inline-input",
                                                    type: "text",
                                                    ref: 'inlineSignageItemRenameInput' + element.id,
                                                    size: "small",
                                                    onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.signageItemNameBeingEditedId = null)),
                                                    autofocus: "",
                                                    onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop","prevent"])),
                                                    "onUpdate:modelValue": ($event: any) => ((element.name) = $event),
                                                    onFocus: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onInlineNameFocus($event)))
                                                  }, null, 40, _hoisted_136)), [
                                                    [_vModelText, element.name]
                                                  ])
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: "dt-list__title signage__editable-table-cell",
                                                    onClick: _withModifiers(($event: any) => (_ctx.inlineSignageItemRenameHandler(element)), ["stop","prevent"])
                                                  }, [
                                                    _createTextVNode(_toDisplayString(element.name) + " ", 1),
                                                    _createVNode(_component_Icon, { icon: _ctx.mdiPencil }, null, 8, ["icon"])
                                                  ], 8, _hoisted_137))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(element.name), 1)),
                                        _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.setLayoutTypeDisplayName(element.layoutType)), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_140, [
                                    _createVNode(_component_el_tooltip, {
                                      disabled: !element.scheduledTimeSet,
                                      "show-after": 200,
                                      placement: "bottom"
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("ul", _hoisted_141, [
                                          (element.isDateEnabled)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_142, _toDisplayString(new Date(element.startDate).toLocaleDateString()) + " - " + _toDisplayString(new Date(element.endDate).toLocaleDateString()), 1))
                                            : _createCommentVNode("", true),
                                          (element.isTimeEnabled)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_143, _toDisplayString(_ctx.convert24to12(element.startTime)) + " - " + _toDisplayString(_ctx.convert24to12(element.endTime)), 1))
                                            : _createCommentVNode("", true),
                                          (element.isDayEnabled)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_144, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.activeDaysOfWeek.sort(_ctx.sortByDay), (day, i) => {
                                                  return (_openBlock(), _createElementBlock("span", {
                                                    key: String(day)
                                                  }, [
                                                    _createTextVNode(_toDisplayString(day), 1),
                                                    (Number(i) < element.activeDaysOfWeek.length - 1)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _createTextVNode(", ")
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_tooltip, {
                                          disabled: _ctx.hasScheduling,
                                          effect: "dark",
                                          content: _ctx.upgradeText,
                                          placement: "bottom",
                                          "hide-after": 0,
                                          "show-after": 500
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", {
                                              onClick: _withModifiers(($event: any) => (_ctx.onMassScheduleClick(element)), ["stop","prevent"]),
                                              class: "cell d-inline-flex align-items-center signage__editable-table-cell float-start"
                                            }, [
                                              _createTextVNode(_toDisplayString(element.scheduledTimeSet ? 'Yes' : 'No') + " ", 1),
                                              _createVNode(_component_Icon, { icon: _ctx.mdiPencil }, null, 8, ["icon"])
                                            ], 8, _hoisted_145)
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "content"])
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled"]),
                                    (_ctx.isListScheuleConflicted(element.id))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                          _createVNode(_component_el_tooltip, {
                                            effect: "dark",
                                            content: "Signage item has a schedule that conflicts with the list schedule.",
                                            placement: "bottom",
                                            "hide-after": 0,
                                            "show-after": 500
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_147, [
                                                (_openBlock(), _createElementBlock("svg", _hoisted_148, [
                                                  _createElementVNode("path", { d: _ctx.mdiExclamationThick }, null, 8, _hoisted_149)
                                                ]))
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_150, [
                                    _createElementVNode("div", _hoisted_151, [
                                      (!element.playUntilEnd && element.finalSignageAsset && element.finalSignageAsset.assetType == 'image')
                                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                            key: 0,
                                            disabled: !_ctx.isImport,
                                            effect: "dark",
                                            content: _ctx.importDurationTooltipText,
                                            placement: "bottom",
                                            "hide-after": 0,
                                            "show-after": 500
                                          }, {
                                            default: _withCtx(() => [
                                              (!element.playUntilEnd && element.finalSignageAsset && element.finalSignageAsset.assetType == 'image')
                                                ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                                                    key: 0,
                                                    "enable-seconds": "",
                                                    clearable: false,
                                                    "hide-input-icon": "",
                                                    "menu-class-name": "signage__time-picker signage__time-picker--duration",
                                                    modelValue: _ctx.durations[element.id],
                                                    "onUpdate:modelValue": [($event: any) => ((_ctx.durations[element.id]) = $event), ($event: any) => (_ctx.onTimePickerUpdate($event, element, 'durationToDisplay'))],
                                                    "time-picker": "",
                                                    "auto-apply": "",
                                                    "min-time": { hours: 0, minutes: 0, seconds: 1 },
                                                    teleport: true,
                                                    disabled: _ctx.isImport
                                                  }, {
                                                    "dp-input": _withCtx(({ value }) => [
                                                      _createElementVNode("div", _hoisted_152, [
                                                        _createElementVNode("span", null, _toDisplayString(value), 1),
                                                        (!_ctx.isImport)
                                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                                              key: 0,
                                                              class: "m-0",
                                                              icon: _ctx.mdiPencil
                                                            }, null, 8, ["icon"]))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1032, ["disabled", "content"]))
                                        : (_openBlock(), _createBlock(_component_el_popover, {
                                            key: 1,
                                            placement: "bottom",
                                            title: !element.playUntilEnd?'Duration':'Loop',
                                            width: 200,
                                            trigger: "click"
                                          }, {
                                            reference: _withCtx(() => [
                                              (!element.playUntilEnd)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "d-flex align-items-center gap-2",
                                                    onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["prevent"]))
                                                  }, [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.displayDuration(element.durationToDisplay)), 1),
                                                    _createVNode(_component_Icon, {
                                                      class: "m-0",
                                                      icon: _ctx.mdiPencil
                                                    }, null, 8, ["icon"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: "d-flex align-items-center gap-2",
                                                    onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"]))
                                                  }, [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.displayLoop(element.playUntilEndLoopCount)), 1),
                                                    _createVNode(_component_Icon, {
                                                      class: "m-0",
                                                      icon: _ctx.mdiPencil
                                                    }, null, 8, ["icon"])
                                                  ]))
                                            ]),
                                            default: _withCtx(() => [
                                              ((element.finalSignageAsset && element.finalSignageAsset.assetType == 'video') || element.layoutType === 'youtubevideo')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                                    _createVNode(_component_el_switch, {
                                                      onClick: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop","prevent"])),
                                                      modelValue: element.playUntilEnd,
                                                      "onUpdate:modelValue": ($event: any) => ((element.playUntilEnd) = $event)
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                    _createTextVNode(" Play until end ")
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (!element.playUntilEnd)
                                                ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                                                    key: 1,
                                                    "enable-seconds": true,
                                                    clearable: false,
                                                    "hide-input-icon": "",
                                                    class: "signage__time-picker signage__time-picker--duration w-100",
                                                    modelValue: _ctx.durations[element.id],
                                                    "onUpdate:modelValue": [($event: any) => ((_ctx.durations[element.id]) = $event), ($event: any) => (_ctx.onTimePickerUpdate($event, element, 'durationToDisplay'))],
                                                    "time-picker": "",
                                                    "auto-apply": "",
                                                    "min-time": { hours: 0, minutes: 0, seconds: 1 },
                                                    teleport: true
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                : (_openBlock(), _createBlock(_component_el_input_number, {
                                                    key: 2,
                                                    modelValue: element.playUntilEndLoopCount,
                                                    "onUpdate:modelValue": ($event: any) => ((element.playUntilEndLoopCount) = $event),
                                                    min: 1,
                                                    size: "small",
                                                    label: "loop",
                                                    class: "w-100"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]))
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_154, [
                                    _createElementVNode("div", _hoisted_155, [
                                      (element.hideFromDisplay || element.storageQuotaMet || _ctx.isLayoutDisbabled(element.layoutType))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (_ctx.isLayoutDisbabled(element.layoutType))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                                  _createVNode(_component_el_tooltip, {
                                                    effect: "dark",
                                                    content: _ctx.layoutToolTipText(element.layoutType),
                                                    placement: "bottom",
                                                    "hide-after": 0,
                                                    "show-after": 500
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, {
                                                        class: "signage__hidden-icon me-2",
                                                        icon: _ctx.mdiAlertCircle
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["content"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (element.storageQuotaMet)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                                  _createVNode(_component_el_tooltip, {
                                                    effect: "dark",
                                                    content: "Item will been hidden due to insufficient storage space",
                                                    placement: "bottom",
                                                    "hide-after": 0,
                                                    "show-after": 500
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, {
                                                        class: "signage__hidden-icon me-2",
                                                        icon: _ctx.mdiFolderAlert
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            (element.hideFromDisplay)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                                                  _createVNode(_component_el_tooltip, {
                                                    effect: "dark",
                                                    content: "Item has been hidden",
                                                    placement: "bottom",
                                                    "hide-after": 0,
                                                    "show-after": 500
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, {
                                                        class: "signage__hidden-icon me-2",
                                                        icon: _ctx.mdiEyeOff
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (_openBlock(), _createBlock(_component_el_popover, {
                                        key: element.id + 'popoover',
                                        visible: _ctx.openSignageItemContextId == element.id,
                                        placement: "left-start",
                                        width: 200,
                                        "hide-after": 0,
                                        "popper-class": "el-popper--subnav"
                                      }, {
                                        reference: _withCtx(() => [
                                          _createVNode(_component_el_button, {
                                            class: "signage__more-actions",
                                            onClick: _withModifiers(($event: any) => (_ctx.onContextClick(element)), ["stop","prevent"]),
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Icon, { icon: _ctx.mdiDotsVertical }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("ul", {
                                            onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop","prevent"])),
                                            class: "el-popover__subnav"
                                          }, [
                                            (!_ctx.isImport)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_159, [
                                                  _createVNode(_component_router_link, {
                                                    to: '/signage/' + _ctx.mutatableSignageItemsStateObject.signageListId + '/' + element.id
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Icon, { icon: _ctx.mdiPencil }, null, 8, ["icon"]),
                                                      _createTextVNode("Edit")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to"])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (!_ctx.isImport)
                                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                  key: 1,
                                                  disabled: _ctx.hasListManagement,
                                                  effect: "dark",
                                                  content: _ctx.upgradeText,
                                                  placement: "bottom",
                                                  "hide-after": 0,
                                                  "show-after": 500
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("button", {
                                                        disabled: !_ctx.hasListManagement,
                                                        onClick: ($event: any) => (_ctx.showHideSignageItems(element))
                                                      }, [
                                                        _createVNode(_component_Icon, {
                                                          icon: element.hideFromDisplay ? _ctx.mdiEye : _ctx.mdiEyeOff
                                                        }, null, 8, ["icon"]),
                                                        _createTextVNode(_toDisplayString(element.hideFromDisplay ? 'Show' : 'Hide'), 1)
                                                      ], 8, _hoisted_160)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "content"]))
                                              : _createCommentVNode("", true),
                                            (!_ctx.isImport)
                                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                  key: 2,
                                                  disabled: _ctx.hasListManagement,
                                                  effect: "dark",
                                                  content: _ctx.upgradeText,
                                                  placement: "bottom",
                                                  "hide-after": 0,
                                                  "show-after": 500
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("button", {
                                                        disabled: !_ctx.hasListManagement,
                                                        onClick: ($event: any) => (_ctx.moveItemHandler(element))
                                                      }, [
                                                        _createVNode(_component_Icon, { icon: _ctx.mdiCursorMove }, null, 8, ["icon"]),
                                                        _createTextVNode("Move")
                                                      ], 8, _hoisted_161)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "content"]))
                                              : _createCommentVNode("", true),
                                            (!_ctx.isImport)
                                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                  key: 3,
                                                  disabled: _ctx.hasListManagement,
                                                  effect: "dark",
                                                  content: _ctx.upgradeText,
                                                  placement: "bottom",
                                                  "hide-after": 0,
                                                  "show-after": 500
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("li", null, [
                                                      (_ctx.allowDuplicate(element) && !_ctx.isStorageFull)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            disabled: !_ctx.hasListManagement,
                                                            onClick: ($event: any) => (_ctx.duplicateItemHandler(element))
                                                          }, [
                                                            _createVNode(_component_Icon, { icon: _ctx.mdiCardMultiple }, null, 8, ["icon"]),
                                                            _createTextVNode("Duplicate")
                                                          ], 8, _hoisted_162))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "content"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_el_tooltip, {
                                              disabled: _ctx.hasScheduling,
                                              effect: "dark",
                                              content: _ctx.upgradeText,
                                              placement: "bottom",
                                              "hide-after": 0,
                                              "show-after": 500
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("li", null, [
                                                  _createElementVNode("button", {
                                                    disabled: !_ctx.hasScheduling,
                                                    onClick: ($event: any) => (_ctx.onMassScheduleClick(element))
                                                  }, [
                                                    _createVNode(_component_Icon, { icon: _ctx.mdiCalendarClock }, null, 8, ["icon"]),
                                                    _createTextVNode("Schedule")
                                                  ], 8, _hoisted_163)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled", "content"]),
                                            _createElementVNode("li", null, [
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.onMassDurationClick(element))
                                              }, [
                                                _createVNode(_component_Icon, { icon: _ctx.mdiClockTimeFive }, null, 8, ["icon"]),
                                                _createTextVNode("Duration")
                                              ], 8, _hoisted_164)
                                            ]),
                                            (!_ctx.isImport)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_165, [
                                                  _createElementVNode("button", {
                                                    class: "delete",
                                                    onClick: ($event: any) => (_ctx.onDeleteClick(element))
                                                  }, [
                                                    _createVNode(_component_Icon, { icon: _ctx.mdiDelete }, null, 8, ["icon"]),
                                                    _createTextVNode("Delete")
                                                  ], 8, _hoisted_166)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["visible"]))
                                    ])
                                  ])
                                ], 8, _hoisted_123)
                              ]),
                              _: 1
                            }, 8, ["disabled", "component-data", "modelValue"])
                          ])
                        ]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_167, [
                    (_ctx.windowWidth.value < 576)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                          _withDirectives((_openBlock(), _createBlock(_component_el_table, { "empty-text": "No signage items" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, { width: "55" }),
                              _createVNode(_component_el_table_column, {
                                type: "selection",
                                width: "55"
                              }),
                              _createVNode(_component_el_table_column, { label: "Signage" })
                            ]),
                            _: 1
                          })), [
                            [_directive_loading, _ctx.isImport && _ctx.importGenerating]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_169, [
                          _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_170, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_171, [
                                  _createElementVNode("div", _hoisted_172, [
                                    _createVNode(_component_el_checkbox, { disabled: true })
                                  ])
                                ]),
                                _hoisted_173,
                                _hoisted_174,
                                _hoisted_175,
                                _hoisted_176
                              ])
                            ]),
                            _hoisted_177
                          ])), [
                            [_directive_loading, _ctx.isImport && _ctx.importGenerating]
                          ])
                        ]))
                  ]))
            ]),
            _: 1
          }),
          (_ctx.listConflict && _ctx.windowWidth.value >= 576)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                disabled: "true",
                name: "status"
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "Signage items in this list have a schedule that conflicts with the list schedule.",
                    placement: "bottom",
                    "hide-after": 0,
                    "show-after": 500
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_178, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_179, [
                          _createElementVNode("path", { d: _ctx.mdiExclamationThick }, null, 8, _hoisted_180)
                        ]))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2)), [
      [_directive_loading, _ctx.isSignageListItemsLoading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.layoutTypeChoiceVisibile,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.layoutTypeChoiceVisibile) = $event)),
      onClose: _ctx.onCloseLayoutTypeChoice,
      "custom-class": "el-dialog--large el-dialog--tabbed",
      onClosed: _ctx.onClosedLayoutTypeChoice,
      ref: "layoutChoiceModal"
    }, {
      title: _withCtx(() => [
        _hoisted_181
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_196, [
          _createVNode(_component_el_button, {
            onClick: _ctx.onCancelLayoutTypeChoice,
            disabled: false
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: "Select a layout type.",
            placement: "bottom",
            "show-after": 0,
            "hide-after": 0,
            disabled: _ctx.selectedLayoutType.name
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_197, [
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.onInitializeSignageItem,
                  disabled: !_ctx.selectedLayoutType.name
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Create")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])), [
                  [_directive_loading, _ctx.isInitializeSignageItemLoading]
                ])
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { ref: "layoutChoiceModalContent" }, {
          default: _withCtx(() => [
            (!_ctx.showAllTemplates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                  _createVNode(_component_TierLimit, {
                    isCallout: true,
                    message: "You do not have access to all signage templates. Upgrade your Ditto account to access more templates."
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_tabs, {
              modelValue: _ctx.selectedLayoutTypeTab,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.selectedLayoutTypeTab) = $event)),
              class: "signage__layout-type-tabs",
              type: "card",
              onTabClick: _ctx.onLayoutChoiceTabClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "General",
                  name: "general"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_183, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutTypes, (layoutType, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          disabled: _ctx.isLayoutDisbabled(layoutType.name),
                          type: "button",
                          onClick: ($event: any) => (_ctx.onSelectLayoutType(layoutType)),
                          class: _normalizeClass(["signage__layout-type-button", { active:  _ctx.selectedLayoutType && _ctx.selectedLayoutType.name == layoutType.name}]),
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_185, [
                            _createVNode(_component_Icon, {
                              class: "signage__layout-type-icon",
                              icon: layoutType.icon
                            }, null, 8, ["icon"]),
                            _createElementVNode("span", null, _toDisplayString(layoutType.displayName), 1),
                            _createElementVNode("p", null, _toDisplayString(layoutType.description), 1)
                          ]),
                          _createVNode(_component_el_tooltip, {
                            disabled: !_ctx.isLayoutDisbabled(layoutType.name),
                            effect: "dark",
                            content: _ctx.layoutToolTipText(layoutType),
                            placement: "bottom",
                            "hide-after": 0,
                            "show-after": 500
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "signage__layout-type-image",
                                src: 'images/signage-layout-images/' + layoutType.name + '.png'
                              }, null, 8, _hoisted_186)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "content"])
                        ], 10, _hoisted_184))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Health & Safety",
                  name: "covid"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_187, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCovidLayoutTypes, (layoutType, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          disabled: _ctx.isLayoutDisbabled(layoutType.name),
                          type: "button",
                          onClick: ($event: any) => (_ctx.onSelectLayoutType(layoutType)),
                          class: _normalizeClass(["signage__layout-type-button", { active:  _ctx.selectedLayoutType && _ctx.selectedLayoutType.name == layoutType.name}]),
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_189, [
                            (typeof layoutType.icon === 'string' && layoutType.icon.startsWith('M'))
                              ? (_openBlock(), _createBlock(_component_Icon, {
                                  key: 0,
                                  icon: layoutType.icon
                                }, null, 8, ["icon"]))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: layoutType.icon,
                                  alt: "icon",
                                  style: {"width":"24px","height":"24px"}
                                }, null, 8, _hoisted_190)),
                            _createElementVNode("span", null, _toDisplayString(layoutType.displayName), 1),
                            _createElementVNode("p", null, _toDisplayString(layoutType.description), 1)
                          ]),
                          _createVNode(_component_el_tooltip, {
                            disabled: !_ctx.isLayoutDisbabled(layoutType.name),
                            effect: "dark",
                            content: _ctx.layoutToolTipText(layoutType),
                            placement: "bottom",
                            "hide-after": 0,
                            "show-after": 500
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "signage__layout-type-image",
                                src: 'images/signage-layout-images/' + layoutType.name + '.png'
                              }, null, 8, _hoisted_191)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "content"])
                        ], 10, _hoisted_188))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Integrations",
                  name: "integrations"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_192, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.integrationLayoutTypes, (layoutType, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          disabled: _ctx.isLayoutDisbabled(layoutType.name),
                          type: "button",
                          onClick: ($event: any) => (_ctx.onSelectLayoutType(layoutType)),
                          class: _normalizeClass(["signage__layout-type-button", { active:  _ctx.selectedLayoutType && _ctx.selectedLayoutType.name == layoutType.name}]),
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_194, [
                            _createVNode(_component_Icon, {
                              class: "signage__layout-type-icon",
                              icon: layoutType.icon
                            }, null, 8, ["icon"]),
                            _createElementVNode("span", null, _toDisplayString(layoutType.displayName), 1),
                            _createElementVNode("p", null, _toDisplayString(layoutType.description), 1)
                          ]),
                          _createVNode(_component_el_tooltip, {
                            disabled: !_ctx.isLayoutDisbabled(layoutType.name),
                            effect: "dark",
                            content: _ctx.layoutToolTipText(layoutType),
                            placement: "bottom",
                            "hide-after": 0,
                            "show-after": 500
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "signage__layout-type-image",
                                src: 'images/signage-layout-images/' + layoutType.name + '.png'
                              }, null, 8, _hoisted_195)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "content"])
                        ], 10, _hoisted_193))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onTabClick"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "onClosed"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
      modelValue: _ctx.isScheduleModalVisible,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.isScheduleModalVisible) = $event)),
      "custom-class": "signage__mass-schedule-dialog",
      onClose: _ctx.onScheduleModalClose,
      onClosed: _ctx.onScheduleModalClosed
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_198, [
          _createVNode(_component_Icon, { icon: _ctx.mdiCalendarClock }, null, 8, ["icon"]),
          _createTextVNode(" Schedule Signage Item" + _toDisplayString(_ctx.signagesPoppedUp.length > 1 ? 's' : ''), 1)
        ]),
        _createElementVNode("p", _hoisted_199, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signagesPoppedUp.slice(0,_ctx.selectedSignageItemsNameCount), (list, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: list.id
            }, [
              _createTextVNode(_toDisplayString(list.name), 1),
              (index < _ctx.signagesPoppedUp.length - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(", ")
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.signagesPoppedUp.length > _ctx.selectedSignageItemsNameCount)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "show-after": 200,
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_200, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signagesPoppedUp.slice(_ctx.selectedSignageItemsNameCount, _ctx.signagesPoppedUp.length), (list) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: list.id
                      }, _toDisplayString(list.name), 1))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, "and " + _toDisplayString(_ctx.signagesPoppedUp.length - _ctx.selectedSignageItemsNameCount) + " more.", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_220, [
          _createVNode(_component_el_button, {
            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isScheduleModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            onClick: _ctx.onScheduleSaveClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save")
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _ctx.isSignageScheduleLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "validate-on-rule-change": false,
          model: _ctx.massScheduleSettings,
          rules: _ctx.scheduleFormRules,
          ref: "scheduleForm",
          class: "signage__schedule-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'signage__mass-scheduling-calendars' : _ctx.windowWidth.value >= 576 })
              }, [
                _createVNode(_component_el_form_item, { prop: "scheduled" }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_201, [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.massScheduleSettings.scheduledTimeSet,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.massScheduleSettings.scheduledTimeSet) = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_202
                    ]),
                    _createElementVNode("span", null, "Set a schedule for the selected signage item" + _toDisplayString(_ctx.signagesPoppedUp.length > 1 ? 's' : '') + ".", 1)
                  ]),
                  _: 1
                }),
                (_ctx.signageList.scheduledTimeSet)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                      _hoisted_204,
                      _createElementVNode("ul", _hoisted_205, [
                        (_ctx.signageList.isDateEnabled)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_206, "Date: " + _toDisplayString(new Date(_ctx.signageList.startDate).toLocaleDateString()) + " - " + _toDisplayString(new Date(_ctx.signageList.endDate).toLocaleDateString()), 1))
                          : _createCommentVNode("", true),
                        (_ctx.signageList.isTimeEnabled)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_207, "Time: " + _toDisplayString(_ctx.convert24to12(_ctx.signageList.startTime)) + " - " + _toDisplayString(_ctx.convert24to12(_ctx.signageList.endTime)), 1))
                          : _createCommentVNode("", true),
                        (_ctx.signageList.isDayEnabled)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_208, [
                              _createTextVNode(" Day: "),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageList.activeDaysOfWeek.sort(_ctx.sortByDay), (day, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: String(day)
                                }, [
                                  _createTextVNode(_toDisplayString(day), 1),
                                  (Number(i) < _ctx.signageList.activeDaysOfWeek.length - 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(", ")
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (!_ctx.massScheduleSettings.scheduledTimeSet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                    _createVNode(_component_Icon, {
                      class: "icon icon--x-large icon--warning",
                      icon: _ctx.mdiAlertCircle
                    }, null, 8, ["icon"]),
                    _hoisted_210
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass({ 'opacity-50' : !_ctx.massScheduleSettings.scheduledTimeSet })
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'signage__mass-scheduling-calendars' : _ctx.windowWidth.value >= 576 })
                }, [
                  _createVNode(_component_el_form_item, { prop: "date" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_211, [
                        _createVNode(_component_el_switch, {
                          disabled: !_ctx.massScheduleSettings.scheduledTimeSet,
                          modelValue: _ctx.massScheduleSettings.isDateEnabled,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.massScheduleSettings.isDateEnabled) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _hoisted_212
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass({ 'signage__inactive-schedule-item' : !_ctx.massScheduleSettings.isDateEnabled })
                      }, [
                        _createVNode(_component_VueDatePicker, {
                          range: true,
                          clearable: false,
                          "hide-input-icon": "",
                          disabled: !_ctx.massScheduleSettings.isDateEnabled || !_ctx.massScheduleSettings.scheduledTimeSet,
                          modelValue: _ctx.massScheduleSettings.dates,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.massScheduleSettings.dates) = $event)),
                          "auto-apply": "",
                          placeholder: "Date / date range",
                          "enable-time-picker": false,
                          "month-change-on-scroll": false,
                          "menu-class-name": "signage__duration-picker",
                          "min-date": new Date(),
                          teleport: true,
                          "week-start": "0",
                          "hide-offset-dates": ""
                        }, null, 8, ["disabled", "modelValue", "min-date"])
                      ], 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { prop: "time" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_213, [
                        _createVNode(_component_el_switch, {
                          disabled: !_ctx.massScheduleSettings.scheduledTimeSet,
                          modelValue: _ctx.massScheduleSettings.isTimeEnabled,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.massScheduleSettings.isTimeEnabled) = $event))
                        }, null, 8, ["disabled", "modelValue"]),
                        _hoisted_214
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass([{ 'signage__inactive-schedule-item' : !_ctx.massScheduleSettings.isTimeEnabled }, "d-flex align-items-center gap-2"])
                      }, [
                        _createVNode(_component_VueDatePicker, {
                          clearable: false,
                          "hide-input-icon": "",
                          modelValue: _ctx.massScheduleSettings.startTime,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.massScheduleSettings.startTime) = $event)),
                          "auto-apply": "",
                          "time-picker": "",
                          disabled: !_ctx.massScheduleSettings.isTimeEnabled || !_ctx.massScheduleSettings.scheduledTimeSet,
                          "is-24": false,
                          "menu-class-name": "signage__duration-picker",
                          placeholder: "Start Time",
                          teleport: true
                        }, null, 8, ["modelValue", "disabled"]),
                        _hoisted_215,
                        _createVNode(_component_VueDatePicker, {
                          clearable: false,
                          "hide-input-icon": "",
                          modelValue: _ctx.massScheduleSettings.endTime,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.massScheduleSettings.endTime) = $event)),
                          "auto-apply": "",
                          disabled: !_ctx.massScheduleSettings.isTimeEnabled || !_ctx.massScheduleSettings.scheduledTimeSet,
                          "time-picker": "",
                          "is-24": false,
                          "menu-class-name": "signage__duration-picker",
                          placeholder: "End Time",
                          teleport: true
                        }, null, 8, ["modelValue", "disabled"])
                      ], 2)
                    ]),
                    _: 1
                  })
                ], 2),
                _createVNode(_component_el_form_item, { prop: "day" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_216, [
                      _createVNode(_component_el_switch, {
                        disabled: !_ctx.massScheduleSettings.scheduledTimeSet,
                        modelValue: _ctx.massScheduleSettings.isDayEnabled,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.massScheduleSettings.isDayEnabled) = $event))
                      }, null, 8, ["disabled", "modelValue"]),
                      _hoisted_217
                    ]),
                    _createElementVNode("ul", {
                      class: _normalizeClass(["signage__days-of-week", { 'signage__inactive-schedule-item' : !_ctx.massScheduleSettings.isDayEnabled || !_ctx.massScheduleSettings.scheduledTimeSet, 'd-block' : _ctx.windowWidth.value < 576 }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day) => {
                        return (_openBlock(), _createElementBlock("li", {
                          onClick: ($event: any) => (_ctx.onDayOfWeekClick(day)),
                          class: _normalizeClass({ active : _ctx.massScheduleSettings.activeDaysOfWeek && _ctx.massScheduleSettings.activeDaysOfWeek.includes(day.value), 'm-2' : _ctx.windowWidth.value < 576 }),
                          key: day.name
                        }, _toDisplayString(day.name), 11, _hoisted_218))
                      }), 128))
                    ], 2)
                  ]),
                  _: 1
                })
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        (_ctx.isScheduleSaveWarningVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
              _createVNode(_component_Icon, {
                class: "icon icon--x-large icon--warning",
                icon: _ctx.mdiAlertCircle
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, "Saving will update existing schedules for selected signage item" + _toDisplayString(_ctx.signagesPoppedUp.length > 1 ? 's' : '') + ".", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "onClosed"])), [
      [_directive_loading, true]
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
      modelValue: _ctx.isDurationModalVisible,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.isDurationModalVisible) = $event)),
      "custom-class": "signage__mass-schedule-dialog",
      onClose: _ctx.onDurationModalClose
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_221, [
          _createVNode(_component_Icon, { icon: _ctx.mdiClockTimeFive }, null, 8, ["icon"]),
          _createTextVNode(" Duration for Signage Item" + _toDisplayString(_ctx.signagesPoppedUp.length > 1 ? 's' : ''), 1)
        ]),
        _createElementVNode("p", _hoisted_222, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signagesPoppedUp.slice(0,_ctx.selectedSignageItemsNameCount), (list, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: list.id
            }, [
              _createTextVNode(_toDisplayString(list.name), 1),
              (index < _ctx.signagesPoppedUp.length - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(", ")
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.signagesPoppedUp.length > _ctx.selectedSignageItemsNameCount)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "show-after": 200,
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_223, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signagesPoppedUp.slice(_ctx.selectedSignageItemsNameCount, _ctx.signagesPoppedUp.length), (list) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: list.id
                      }, _toDisplayString(list.name), 1))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, "and " + _toDisplayString(_ctx.signagesPoppedUp.length - _ctx.selectedSignageItemsNameCount) + " more.", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_232, [
          _createVNode(_component_el_button, {
            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.isDurationModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            onClick: _ctx.onDurationSaveClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save")
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _ctx.isDurationScheduleLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.massDurationSettings.showDuration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                _hoisted_225,
                _createElementVNode("div", _hoisted_226, [
                  _createVNode(_component_VueDatePicker, {
                    "enable-seconds": true,
                    clearable: false,
                    "hide-input-icon": "",
                    modelValue: _ctx.massDurationSettings.durationToDisplay,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.massDurationSettings.durationToDisplay) = $event)),
                    "time-picker": "",
                    "auto-apply": "",
                    "min-time": { hours: 0, minutes: 0, seconds: 1 },
                    position: "left",
                    teleport: true
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.massDurationSettings.showLoop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                _createElementVNode("h2", {
                  class: _normalizeClass(_ctx.massDurationSettings.showDuration ? 'mt-4' : 'mt-0')
                }, "Video " + _toDisplayString(_ctx.massDurationSettings.playUntilEnd ? 'Loop' : 'Duration'), 3),
                _createElementVNode("div", _hoisted_228, [
                  _createElementVNode("div", _hoisted_229, [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.massDurationSettings.playUntilEnd,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.massDurationSettings.playUntilEnd) = $event)),
                      class: "mb-3"
                    }, null, 8, ["modelValue"]),
                    _hoisted_230
                  ]),
                  (!_ctx.massDurationSettings.playUntilEnd)
                    ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                        key: 0,
                        "enable-seconds": true,
                        clearable: false,
                        "hide-input-icon": "",
                        modelValue: _ctx.massDurationSettings.durationToDisplay,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.massDurationSettings.durationToDisplay) = $event)),
                        "time-picker": "",
                        "auto-apply": "",
                        "min-time": { hours: 0, minutes: 0, seconds: 1 },
                        position: "left",
                        teleport: true
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_input_number, {
                        key: 1,
                        modelValue: _ctx.massDurationSettings.playUntilEndLoopCount,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.massDurationSettings.playUntilEndLoopCount) = $event)),
                        min: 1,
                        size: "small",
                        label: "loop",
                        class: "w-100"
                      }, null, 8, ["modelValue"]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.signagesPoppedUp.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
              _createVNode(_component_Icon, {
                class: "icon icon--x-large icon--warning",
                icon: _ctx.mdiAlertCircle
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, "Saving will update existing durations for selected signage item" + _toDisplayString(_ctx.signagesPoppedUp.length > 1 ? 's' : '') + ".", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])), [
      [_directive_loading, true]
    ]),
    _createVNode(_component_ModelSelector, {
      title: "Add Rooms to Signage List",
      subTitle: _ctx.signageList ? _ctx.signageList.name : '',
      loading: _ctx.isSetRoomsLoading,
      modelTypeName: "rooms",
      onSelectionPoolChange: _ctx.roomSelectionChanged,
      showRemoveRoomMessage: _ctx.isRoomRestricted,
      showNoAccessRoomMessage: _ctx.showNoAccessRoomMessage,
      ref: "roomModelSelector"
    }, null, 8, ["subTitle", "loading", "onSelectionPoolChange", "showRemoveRoomMessage", "showNoAccessRoomMessage"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
      modelValue: _ctx.isDeleteModalVisible,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.isDeleteModalVisible) = $event)),
      onClose: _cache[51] || (_cache[51] = ($event: any) => (_ctx.isDeleteModalVisible = false))
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_233, "Delete Signage Item" + _toDisplayString(_ctx.signagesPoppedUp.length > 1 ? 's' : ''), 1),
        _createElementVNode("p", _hoisted_234, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signagesPoppedUp.slice(0,2), (list, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: list.id
            }, [
              _createTextVNode(_toDisplayString(list.name), 1),
              (index < _ctx.signagesPoppedUp.length - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(", ")
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.signagesPoppedUp.length > 2)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "show-after": 200,
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_235, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signagesPoppedUp.slice(2, _ctx.signagesPoppedUp.length), (list) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: list.id
                      }, _toDisplayString(list.name), 1))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, "and " + _toDisplayString(_ctx.signagesPoppedUp.length - 2) + " more.", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_237, [
          _createVNode(_component_el_button, {
            onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.isDeleteModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "danger",
            onClick: _ctx.massDelete
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete")
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _ctx.isSignageDeleteLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, "This action will delete the selected signage item" + _toDisplayString(_ctx.signagesPoppedUp.length > 1 ? 's' : '') + ".", 1),
        _createElementVNode("p", _hoisted_236, "Are you sure you want to delete " + _toDisplayString(_ctx.signagesPoppedUp && _ctx.signagesPoppedUp.length == 1 ? _ctx.signagesPoppedUp[0].name : `${ _ctx.signagesPoppedUp.length } signage items`) + "?", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])), [
      [_directive_loading, true]
    ]),
    _createVNode(_component_SignageListSelectionModal, {
      modelValue: _ctx.moveListVisible,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.moveListVisible) = $event)),
      poppedUpList: _ctx.poppedUpList,
      signageLists: _ctx.allSignageLists,
      loading: _ctx.isSignageListsMoveLoading,
      onModalClosed: _cache[53] || (_cache[53] = ($event: any) => (_ctx.moveListVisible = false)),
      onMoveSignages: _ctx.moveSignagesHandler
    }, null, 8, ["modelValue", "poppedUpList", "signageLists", "loading", "onMoveSignages"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isMassUploadModalVisible,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.isMassUploadModalVisible) = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      title: _withCtx(() => [
        _hoisted_238
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_262, [
          _createVNode(_component_el_button, {
            disabled: _ctx.isMassMediaUploading,
            onClick: _ctx.cancelMassMediaUpload
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            disabled: !_ctx.uploadFiles.length || _ctx.isMassMediaUploading || _ctx.isStorageFull || _ctx.isOverUploadLimit || _ctx.checkIfThereIsAnInvalidFile ,
            type: "primary",
            onClick: _ctx.onMassUpload
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.massUploadText), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])), [
            [_directive_loading, _ctx.isMassMediaUploading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.showUploadFilesProgress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
              _createElementVNode("span", null, _toDisplayString(_ctx.processedFileCount) + "/" + _toDisplayString(_ctx.totalFiles) + " media items uploaded", 1),
              _createVNode(_component_el_progress, {
                class: "m-2",
                percentage: _ctx.uploadFilesProgressPercentage,
                "stroke-width": 20,
                "show-text": false
              }, null, 8, ["percentage"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_ctx.showDropZone)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["drop-area", { active :  _ctx.dropZoneHovered }]),
                id: "drop-area",
                ref: "dropArea",
                onDragenter: _cache[55] || (_cache[55] = ($event: any) => (_ctx.dragEnterHandler($event))),
                onDragleave: _cache[56] || (_cache[56] = ($event: any) => (_ctx.dragLeaveHandler($event))),
                onDragover: _cache[57] || (_cache[57] = ($event: any) => (_ctx.dragOverHandler($event))),
                onDrop: _cache[58] || (_cache[58] = ($event: any) => (_ctx.dropHandler($event)))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_240, [
                    _createElementVNode("em", null, [
                      _createVNode(_component_el_button, { type: "text" }, {
                        default: _withCtx(() => [
                          _createElementVNode("label", _hoisted_241, [
                            _createTextVNode("Browse files"),
                            _createElementVNode("input", {
                              type: "file",
                              multiple: "",
                              id: "fileInput",
                              onChange: _cache[54] || (_cache[54] = ($event: any) => (_ctx.onUploadFileInputChange($event)))
                            }, null, 32)
                          ])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" or drag-and-drop here. ")
                    ])
                  ]),
                  _hoisted_242
                ])
              ], 34))
            : _createCommentVNode("", true),
          (_ctx.showPreview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                (!_ctx.isMassMediaUploading)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["text-end", { 'mt-3' : _ctx.showDropZone}])
                    }, [
                      (!_ctx.showDropZone)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.showDropZone=true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Add More")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, { onClick: _ctx.clearFiles }, {
                        default: _withCtx(() => [
                          _createTextVNode("Clear All")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_244, [
                  _createElementVNode("div", _hoisted_245, [
                    _createVNode(_component_el_table, {
                      data: _ctx.uploadFiles,
                      "show-header": false,
                      "row-class-name": _ctx.tableRowStatus,
                      "max-height": "250"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { width: "100" }, {
                          default: _withCtx((scope) => [
                            (!scope.row.isValid || scope.row.uploadFailed)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  content: _ctx.imageTooltipText(scope.row),
                                  "hide-after": 0,
                                  placement: "bottom"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_246, [
                                      (scope.row.isVideo)
                                        ? (_openBlock(), _createElementBlock("video", {
                                            key: 0,
                                            class: "mass-upload__item-image",
                                            src: scope.row.preview
                                          }, null, 8, _hoisted_247))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            class: "mass-upload__item-image",
                                            src: scope.row.preview
                                          }, null, 8, _hoisted_248)),
                                      (!scope.row.isValid || scope.row.uploadFailed)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                            _createVNode(_component_Icon, {
                                              class: _normalizeClass([{'icon--warning': !scope.row.isValid, 'icon--danger': scope.row.uploadFailed}, "icon icon--x-large"]),
                                              icon: _ctx.mdiAlertCircle
                                            }, null, 8, ["class", "icon"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.idBeingProcessed == scope.row.id)
                                        ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                            key: 3,
                                            class: "signage__item-image-building"
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["content"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_250, [
                                  (scope.row.isVideo)
                                    ? (_openBlock(), _createElementBlock("video", {
                                        key: 0,
                                        class: "mass-upload__item-image",
                                        src: scope.row.preview
                                      }, null, 8, _hoisted_251))
                                    : (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        class: "mass-upload__item-image",
                                        src: scope.row.preview
                                      }, null, 8, _hoisted_252)),
                                  (_ctx.idBeingProcessed == scope.row.id)
                                    ? (_openBlock(), _createBlock(_component_InlineTextLoader, {
                                        key: 2,
                                        class: "signage__item-image-building"
                                      }))
                                    : _createCommentVNode("", true)
                                ]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, null, {
                          default: _withCtx((scope) => [
                            _createElementVNode("span", null, _toDisplayString(scope.row.uploadFile.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { width: "95" }, {
                          default: _withCtx((scope) => [
                            (scope.row.isVideo)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                                  _hoisted_254,
                                  _createVNode(_component_el_switch, {
                                    disabled: _ctx.isMassMediaUploading,
                                    modelValue: scope.row.playSound,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.playSound) = $event),
                                    onClick: ($event: any) => (_ctx.updatePlaySound(scope.row))
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { width: "45" }, {
                          default: _withCtx((scope) => [
                            (!_ctx.isMassMediaUploading)
                              ? (_openBlock(), _createBlock(_component_Icon, {
                                  key: 0,
                                  class: "icon icon--large icon--danger",
                                  icon: _ctx.mdiCloseCircleOutline,
                                  onClick: ($event: any) => (_ctx.onRemove(scope.row))
                                }, null, 8, ["icon", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data", "row-class-name"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isOverUploadLimit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
              _hoisted_256,
              _createElementVNode("span", null, [
                _hoisted_257,
                _createTextVNode(". You may add up to " + _toDisplayString(_ctx.uploadLimit) + " media files at a time.", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isStorageFull)
          ? (_openBlock(), _createElementBlock("div", _hoisted_258, _hoisted_261))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierDialog,
      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.showTierDialog) = $event)),
      isCallout: false,
      isLimit: true,
      message: _ctx.tierLimitReachedMessage,
      onModalClosed: _cache[62] || (_cache[62] = ($event: any) => (_ctx.showTierDialog = false))
    }, null, 8, ["modelValue", "message"])
  ]))
}